import { List, ReferenceInput, SelectField, SelectInput, SimpleList, TextInput } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { Datagrid, ReferenceField, TextField } from "react-admin";
import { FailedDisciplinesPanel } from "./components/FailedDisciplinesPanel";
import { FailedDisciplinesMobilePanel } from "./components/FailedDisciplinesMobilePanel";
import { CourseChoices, DecisionReasonChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { EmptyList } from "server/components";
import { settings } from "app";
import { useMediaQuery } from "@mui/material";
import AdvanceButton from "./components/AdvanceButton";
import InterruptButton from "./components/InterruptButton";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { mguExporter } from "utils/tenants";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <TextInput
    label="Фак. №"
    source="facultyNumber"
    alwaysOn
  />,
  <ReferenceInput
    source="specialityId"
    reference={administrationRequests.getSpecialitiesSelect()}
    label="Специалност"
    alwaysOn
  >
    <SelectInput
      label="Специалност"
      emptyText="Всички"
      style={{ minWidth: 280 }}
    />
  </ReferenceInput>,
  <SelectInput
    source="currentCourse"
    label="Курс"
    choices={CourseChoices}
    alwaysOn
    emptyText="Всички"
  />,
  <SelectInput
    source="reason"
    label="Причина"
    choices={DecisionReasonChoices}
    alwaysOn
    emptyText="Всички"
  />,
];

const ListPendingDecisions = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Прекъсващи за слаб успех"
      filters={filters}
      actions={false}
      exporter={mguExporter}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => `${record.firstName} ${record.lastName}`}
          secondaryText={record => (
            <>
              <div>
                <MobileListRow fields={[{ label: "Факултетен №", value: record.facultyNumber }]} />
                <MobileListRow
                  fields={[
                    {
                      label: "Курс",
                      value: (
                        <SelectField
                          source="currentCourse"
                          label="Курс"
                          choices={CourseChoices}
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Причина",
                      value: (
                        <SelectField
                          source="reason"
                          label="Причина"
                          choices={DecisionReasonChoices}
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Специалност",
                      value: (
                        <ReferenceField
                          source="specialityId"
                          reference={administrationRequests.getSpecialitiesSelect()}
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
              </div>
              <FailedDisciplinesMobilePanel />
            </>
          )}
        />
      ) : (
        <Datagrid
          expand={FailedDisciplinesPanel}
          bulkActionButtons={
            <SecuredComponent permission={permissions.canManageAcademicDecisions}>
              <AdvanceButton />
              <InterruptButton />
            </SecuredComponent>
          }
        >
          <TextField
            source="facultyNumber"
            label="Факултетен №"
          />
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <SelectField
            source="currentCourse"
            label="Курс"
            choices={CourseChoices}
          />
          <ReferenceField
            source="specialityId"
            label="Специалност"
            reference={administrationRequests.getSpecialitiesSelect()}
          >
            <TextField
              label="Специалност"
              source="name"
            />
          </ReferenceField>
          <SelectField
            source="reason"
            label="Причина"
            choices={DecisionReasonChoices}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListPendingDecisions;
